import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import withNotifications from 'components/shared/notifications'
import { getPardotConfig, patchPardotConfig } from 'app/modules/integrations/api'
import IntegrationToggles from 'components/IntegrationToggles'
import { model, hydrateModel } from './model'
import { Icon } from '@driftt/tide-core-legacy'
import { PARDOT_APP_ID } from 'constants/ResourcesConstants'

import './style.styl'

const CONNECT_ERROR_MESSAGE = 'We could not fetch your Pardot settings.'

class PardotConfig extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    pardotSyncProspectsEnabled: model[0],
    pardotShouldOnlySyncQualifiedContacts: model[1],
    pardotShouldSetLeadOwner: model[2],
    syncConversationTranscriptsEnabled: model[3],
    pardotShouldSetProspectCampaign: model[4],
    cookieIdentificationEnabled: model[5]
  }

  componentDidMount() {
    getPardotConfig()
        .then(this.receiveToggles)
        .catch(this.onError)
  }

  onError = () => {
    const { router } = this.context

    this.props.notifications.error(CONNECT_ERROR_MESSAGE)
    // router.push({ pathname: `/settings/setup/${PARDOT_APP_ID}` })
  }

  onPatchError = () => {
    this.props.notifications.error(PATCH_ERROR_MESSAGE)
  }

  receiveToggles = resp => {
    const hydratedModel = hydrateModel(resp)
    this.setState({
      pardotSyncProspectsEnabled: hydratedModel[0],
      pardotShouldOnlySyncQualifiedContacts: hydratedModel[1],
      pardotShouldSetLeadOwner: hydratedModel[2],
      syncConversationTranscriptsEnabled: hydratedModel[3],
      pardotShouldSetProspectCampaign: hydratedModel[4],
      cookieIdentificationEnabled: hydratedModel[5]
    })
  }

  settingsUpdatedNotification = () => this.props.notifications.success('Pardot settings are updated!')

  patchToggle = (event, toggle) => {
    const data = { [toggle.type]: event }

    patchPardotConfig(data)
      .then(this.receiveToggles)
      .then(this.settingsUpdatedNotification)
      .catch(this.onPatchError)
  }

  settingsUpdatedNotification = () => this.props.notifications.success('Pardot settings are updated!')

  render() {
    const {
      pardotSyncProspectsEnabled,
      pardotShouldOnlySyncQualifiedContacts,
      pardotShouldSetLeadOwner,
      syncConversationTranscriptsEnabled,
      pardotShouldSetProspectCampaign,
      cookieIdentificationEnabled
    } = this.state

    // drift -> pardot toggles
    const driftPardotToggles = [
      pardotSyncProspectsEnabled,
      pardotShouldOnlySyncQualifiedContacts,
      pardotShouldSetLeadOwner,
      syncConversationTranscriptsEnabled,
      pardotShouldSetProspectCampaign
    ]

    // pardot -> drift toggles
    const pardotDriftToggles = [
      cookieIdentificationEnabled
    ]

    return (
        <div className="common-integration-page-layout">
            <IntegrationBreadcrumb
                backLinkText="Pardot Integration"
                backLinkUrl={`/settings/setup/pardot`}
            />
            <header>
                <h2 className="integration-header">Synced Pardot Data</h2>
                <p>Choose which data is sent between Pardot and Drift.</p>
            </header>

            <h3 className="integration-header">
                Drift
                <Icon
                    className="right-arrow"
                    width={15}
                    height={10}
                    name="arrow-2-right"
                />
                Pardot
            </h3>

            <IntegrationToggles
                toggles={driftPardotToggles}
                onChange={this.patchToggle}
                onSuccess={this.settingsUpdatedNotification}
            />

            <h3 className="integration-header">
                Pardot
                <Icon
                className="right-arrow"
                width={15}
                height={10}
                name="arrow-2-right"
                />
                Drift
            </h3>
            <IntegrationToggles
                toggles={pardotDriftToggles}
                onChange={this.patchToggle}
                onSuccess={this.settingsUpdatedNotification}
            />
        </div>
    )
  }
}

export default withNotifications(PardotConfig)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotConfig/index.js